import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class EmbedKeyModel extends ModeModelBase {
  override _name = 'embedKey';
  override idAttribute = 'token';
  override belongsTo = 'report';
  override parentIdAttribute = 'token';
  override attributes = [{ name: 'value', default: '' }];
}

@Injectable({ providedIn: 'root' })
export class EmbedKeyModelAccessor extends ModelAccessorBase<EmbedKeyModel> {
  override name = 'embedKey';
  override parentModel = 'report';
  override parentIdAttribute = 'token';
  override createAttributes = [];
  override getIdFromLink = (link) => {
    return link.split('/embed_keys/')[1].split('?')[0];
  };

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.embedKey');
  }

  createModel(resource, opts?) {
    const model = new EmbedKeyModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
